import { getKsdmConfig } from 'helpers/index';

/**
 * `footer#ksdm-footer`, user-settings variant
 * (`django/user_settings/templates/userSettingsBase.html:25-31`).
 *
 * Unlike `sizerBase.html` / `partnersBase.html` this shell DOES `{% include
 * 'common/footer.html' %}` — the same include `PageFooter` re-platforms — but
 * it wraps it in `div.col-xs-12 > div.row` and puts a `user_settings_footer`
 * class on the `<footer>` itself. That class is load-bearing: both
 * `skeleton.css:131-134` and `styles.css:132-135` give it
 * `margin-left: 230px; width: calc(100% - 235px) !important` so the footer
 * clears the 225px settings rail. `PageFooter` cannot express a class on the
 * `<footer>` element, so — like the sizer and partners ports — this route ships
 * its own copy rather than widening the shared component's props.
 *
 * The version block keeps `common/footer.html`'s `{% if versions.software %}`
 * guard. `versions.cms` is the composed `C.{Ymd}.{version}` token that
 * `react_views._cms_version` builds, i.e. exactly the string the Django
 * template assembles inline from `cms_version`.
 */
const UserSettingsFooter = () => {
  const cfg = getKsdmConfig();
  const year = cfg?.year ?? new Date().getFullYear();
  const software = cfg?.versions?.software;
  const master = cfg?.versions?.master;
  const cmsVersion = cfg?.versions?.cms;

  return (
    <footer id="ksdm-footer" className="user_settings_footer">
      <div className="col-xs-12">
        <div className="row">
          <div className="text-right">
            <small id="ksdm-copyright" className="right mt-0">
              Powered by Kinetix Air | &#169; {year} Kinetix Software LLC | All Rights Reserved
            </small>
          </div>
          {software && (
            <div className="">
              <small id="ksdm-dbs-version" className="mt-0">
                <span className="ka-has-tooltip" tooltip="Software version">
                  {software}
                </span>{' '}
                |{' '}
                <span className="ka-has-tooltip" tooltip="Master DB version">
                  {master}
                </span>{' '}
                |{' '}
                <span className="ka-has-tooltip cms_version" tooltip="CMS DB version">
                  {cmsVersion}
                </span>
              </small>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default UserSettingsFooter;
